import React from 'react';

const categories = [
  { label: 'Management Quality', score: 8, color: 'bg-blue-500' },
  { label: 'Competitive Position', score: 7, color: 'bg-indigo-500' },
  { label: 'Financial Health', score: 9, color: 'bg-emerald-500' },
  { label: 'Growth Prospects', score: 6, color: 'bg-amber-500' },
];

const Preview: React.FC = () => (
  <div className="h-full bg-white p-4 flex flex-col">
    <div className="text-sm font-semibold text-gray-700 mb-1">Conviction</div>
    <div className="flex items-center gap-2 mb-4">
      <span className="text-3xl font-bold text-blue-600">7.5</span>
      <span className="text-xs text-gray-400">/ 10 Overall Score</span>
    </div>
    <div className="flex-1 space-y-3 overflow-hidden">
      {categories.map(c => (
        <div key={c.label}>
          <div className="flex justify-between text-xs mb-1">
            <span className="text-gray-600">{c.label}</span>
            <span className="font-medium text-gray-800">{c.score}</span>
          </div>
          <div className="h-2 bg-gray-100 rounded-full overflow-hidden">
            <div className={`h-full rounded-full ${c.color}`} style={{ width: `${c.score * 10}%` }} />
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default Preview;
